import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User edits session duration unit select box',
  name: 'edited_session_duration_unit',
  params: [
    {
      description: 'Duration period (in seconds)',
      name: 'session_duration_time',
      required: true,
      type: 'number',
    },
    {
      description: 'The unit of value (days, hours, minutes) the user chose from the select box',
      name: 'session_duration_unit',
      required: true,
      type: 'enum',
      values: ['day', 'hr', 'min'],
    },
  ],
};

export default META;
